export const MENU_ITEM = {
  HOME: "home",
  CALENDAR: "calendar",
  MEMBERSHIP: "membership",
  TRIBE: "tribe",
  PROFILE: "profile",
};

export const APP_ROLE = "ADMIN";
export const USER_TYPE = "ADMIN";
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DATE_FORMAT = "DD MMM, YYYY";
export const API_DATE_FORMAT = "YYYY-MM-DD";

export const CALENDAR_RESERVATION_TYPE = {
  DF_WORKSPACE: "DF_WORKSPACE",
  MB_STUDIO: "MB_STUDIO",
  EVENTS: "EVENTS",
  WORKSHOP: "WORKSHOP",
  MEETING_ROOMS: "MEETING_ROOMS",
};

export const CALENDAR_RESERVATION_TABS = [
  { name: "DF Workspace", value: "DF_WORKSPACE" },
  {
    name: "MB Studio",
    value: "MB_STUDIO",
  },
  {
    name: "Events",
    value: "EVENTS",
  },
  {
    name: "Workshops",
    value: "WORKSHOP",
  },
  {
    name: "Meeting Rooms",
    value: "MEETING_ROOMS",
  },
];

export const MEETING_ROOM_TYPE = [
  { name: "1 Seater", value: "ONE_SEATER", count: 1 },
  {
    name: "2 Seater",
    value: "TWO_SEATER",
    count: 2,
  },
  {
    name: "3 Seater",
    value: "THREE_SEATER",
    count: 3,
  },
  {
    name: "4 Seater",
    value: "FOUR_SEATER",
    count: 4,
  },
];
